import styled from 'styled-components';
import { CalendarContainer } from '../Calendar/styles';
import { PseudoCalendarContainer } from '../PseudoCalendar/styles';

export const CalendarWithWavesContainer = styled(CalendarContainer)`
    .time-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        gap: 0.5rem;
    }

    .category-wrapper {
        display: flex;
        width: 100%;
        gap: 0.75rem;
    }
`;

export const TimeButton = styled.button`
    position: relative;
    display: flex;
    padding: 0.5rem 0.75rem;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;

    border: 2px solid #ededed;
    color: var(--Neutral-800, #27272a);
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1rem;
    border-radius: 0.75rem;

    background: none;
    cursor: pointer;
    transition: 0.2s;

    &[aria-selected='true'] {
        border: 2px solid var(--Supernova-500, #ffcf00);
        background: var(--Supernova-50, #fffee7);
    }

    & > svg {
        position: absolute;
        left: -0.375rem;
        top: -0.4375rem;
        width: 1.25rem;
        height: 1.25rem;
        color: #ffcf00;
        fill: #ffcf00;
        filter: drop-shadow(2px 2px 1px rgba(0, 0, 0, 0.05));
    }
`;

export const CustomDropdown = styled(PseudoCalendarContainer)`
    justify-content: space-between;
    flex: 1 0 0;
    svg {
        width: 1.25rem;
        height: 1.25rem;
    }
    padding: 0;

    > button {
        padding: 0;
        border: none;
        pointer-events: all;
        height: 100%;
        align-items: center;
        min-width: 100% !important;
        padding: 0.75rem 1rem;

        color: var(--Neutral-950, #09090b);
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5rem;
    }
`;
